module.exports = __webpack_public_path__ + "img/inventory_mode-bg.dc17c3d3.png";